import { render, staticRenderFns } from "./ManageSalesTrafficPage.vue?vue&type=template&id=7edbde80&scoped=true&"
import script from "./ManageSalesTrafficPage.vue?vue&type=script&lang=js&"
export * from "./ManageSalesTrafficPage.vue?vue&type=script&lang=js&"
import style0 from "./ManageSalesTrafficPage.vue?vue&type=style&index=0&id=7edbde80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edbde80",
  null
  
)

export default component.exports